import axios from 'axios';
import globals from "../config/appconfig";
import Utils from "../utils/Utils";

export default class AnnunciService {

    static urlAnnunci = globals["app-url-backend-assistenti"] + "/annunci"

    static getAnnunciByCodiceFiscale() {
        return axios.get(this.urlAnnunci)
    }

    static inserisciAnnuncio(annuncioDTO) {
        return axios.post(this.urlAnnunci, annuncioDTO)
    }

    static modificaAnnuncio(id, annuncioDTO) {
        return axios.put(this.urlAnnunci + "/" + id, annuncioDTO)
    }

    static eliminaAnnuncio(id) {
        return axios.delete(this.urlAnnunci + "/" + id)
    }

    static getAllAnnunci(params) {
        return axios.get(this.urlAnnunci + "/tutti" + Utils.addQueryParamsToRequestUrl(params))
    }

    static getAllAnnunciConContatto(params) {
        return axios.get(this.urlAnnunci + "/tutti/contatti" + Utils.addQueryParamsToRequestUrl(params))
    }
}
